<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <button v-if="userType != 1" class="btn btn-primary my-3" v-bind="attrs" v-on="on">
        {{ $t("quickUser.changePassword") }}
      </button>
    </template>

    <v-card>
      <v-container>
        <v-card-title>
          <span class="text-h5"> {{ this.title }}</span>
        </v-card-title>

        <v-card-subtitle>
          <p class="text-left text-muted font-weight-bold">
            {{ this.subTitle }}
          </p>
        </v-card-subtitle>
        <v-card-text class="login-form login-forgot">
          <v-form ref="form" class="mt-15" v-model="form.valid" lazy-validation>
            <div class="form-group">
              <v-text-field
                label="Email"
                prepend-inner-icon="mdi-at"
                v-model="form.email"
              />
            </div>
            <v-card-actions class="align-center justify-center">
              <div class="d-flex flex-wrap">
                <button
                  @click="submit"
                  :class="`btn btn-primary font-weight-bolder font-size-h6 ${
                    loading ? 'spinner spinner-light spinner-left' : ''
                  }`"
                >
                  {{ $t("common.submit") }}
                </button>
              </div>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "../../core/services/api.service";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
/*eslint no-control-regex: "off"*/
export default {
  name: "forgotFormQuickUser",
  props: {
    title: String,
    subTitle: String,
  },  
  computed: {
    ...mapGetters(["currentUser"]),
    userType(){
      return this.currentUser["type"];
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      successes: [],
      form: {
        valid: false,
        email: "",
        emailErrors: [
          (v) =>
            !!v ||
            new RegExp(
              "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
            ).test(v) ||
            this.$t("login.emailRequired"),
        ],
      },
    };
  },
  methods: {
    submit(e) {
      e.preventDefault();
      let self = this;
      if (this.$refs.form.validate()) {
        self.loading = true;
        Api.post("/forgot_password/", { email: self.form.email })
          .then((response) => {
            if (response.status >= 200 && response.status < 300) {
              Swal.fire({
                title: "",
                text: self.$i18n.t("login.forgotTextQuickUser"),
                icon: "success",
                heightAuto: false,
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "",
              text: self.$i18n.t("common.errorOccurred"),
              icon: "error",
              heightAuto: false,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>